import { render, staticRenderFns } from "./LaxContainer.vue?vue&type=template&id=67cbc5fd&"
import script from "./LaxContainer.vue?vue&type=script&lang=ts&"
export * from "./LaxContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports